"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKIN_TONES = void 0;
exports.SKIN_TONES = [
    { tone: 1, color: '#33200F' },
    { tone: 2, color: '#4B2E19' },
    { tone: 3, color: '#7C4F2C' },
    { tone: 4, color: '#A76B48' },
    { tone: 5, color: '#C0926E' },
    { tone: 6, color: '#CD9A72' },
    { tone: 7, color: '#E8C9A6' },
    { tone: 8, color: '#F0DFD1' },
];
